import cx from 'classnames';

import { IconStar } from '../../icons/material/rounded/Star';
import { IconStarHalf } from '../../icons/material/rounded/StarHalf';
import { IconStarOutlined } from '../../icons/material/rounded/StarOutlined';

import style from './Stars.module.css';

type IconComponent = typeof IconStar | typeof IconStarOutlined | typeof IconStarHalf;

interface StarsProps {
    variant: 'default' | 'single-star';
    icons: IconComponent[];
    ariaLabel: string;
    size: 'xxs' | 'xs' | 'small' | 'medium' | 'large';
    inverse?: boolean;
    starColor?: 'yellow' | 'black';
}

export function Stars({ variant, icons, ariaLabel, size, starColor = 'yellow' }: StarsProps) {
    return (
        <div
            role="img"
            aria-label={ariaLabel}
            className={cx(style.icons, {
                [style.yellow]: starColor === 'yellow',
                [style.black]: starColor === 'black',
            })}
        >
            {variant === 'single-star' ? (
                <IconStar
                    className={cx(style.icon, {
                        [style.iconXXS]: size === 'xxs',
                        [style.iconXS]: size === 'xs',
                        [style.iconSmall]: size === 'small',
                        [style.iconLarge]: size === 'large',
                    })}
                />
            ) : (
                icons.map((Icon, index) => (
                    <Icon
                        key={index}
                        className={cx(style.icon, {
                            [style.iconXXS]: size === 'xxs',
                            [style.iconXS]: size === 'xs',
                            [style.iconSmall]: size === 'small',
                            [style.iconLarge]: size === 'large',
                        })}
                    />
                ))
            )}
        </div>
    );
}
